// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2O1cI","cardCol":"cardCol--2JohK"};